import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HouseholdComposition from './household-composition';
import HouseholdCompositionDetail from './household-composition-detail';
import HouseholdCompositionUpdate from './household-composition-update';
import HouseholdCompositionDeleteDialog from './household-composition-delete-dialog';

const HouseholdCompositionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HouseholdComposition />} />
    <Route path="new" element={<HouseholdCompositionUpdate />} />
    <Route path=":id">
      <Route index element={<HouseholdCompositionDetail />} />
      <Route path="edit" element={<HouseholdCompositionUpdate />} />
      <Route path="delete" element={<HouseholdCompositionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HouseholdCompositionRoutes;
